<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :value="edit"
    max-width="600px"
    retain-focus
    v-on:click:outside="goToShow"
    v-on:keydown.esc="$router.push('/rawmaterial')"
  >
    <v-card>
      <v-card-title tabindex="-1">
        <span class="headline">Edit Raw Material</span>
        <v-btn
          style="position: absolute; top: 0; right: 0;"
          @click="goToShow"
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-on:submit.prevent width="100%" ref="editForm" v-model="createValid">
          <v-text-field
            :rules="validationRules.name"
            v-model="editFields.name"
            label="Raw Material Name*"
            required
            name="name"
            :error-messages="inputErrorMessages('name')"
            v-on:keyup.enter="saveRawMaterial"
            ref="name"
            tabindex="0"
          />
          <v-text-field
            :rules="validationRules.cost"
            v-model="editFields.cost"
            label="Cost*"
            required
            name="cost"
            :error-messages="inputErrorMessages('cost')"
            v-on:keyup.enter="saveRawMaterial"
            ref="cost"
            tabindex="1"
          />
          <v-text-field
            :disabled="true"
            :rules="validationRules.quantity"
            v-model="editFields.quantity"
            label="Initial Quantity/Weight*"
            required
            name="quantity"
            :error-messages="inputErrorMessages('quantity')"
            v-on:keyup.enter="saveRawMaterial"
            ref="quantity"
            tabindex="2"
          ></v-text-field>
          <v-select
            :rules="validationRules.unit_type"
            v-model="editFields.unit_type"
            :items="units"
            item-text="name"
            item-value="name"
            label="Unit*"
            required
            name="unit_type"
            :error-messages="inputErrorMessages('unit_type')"
            v-on:keyup.enter="saveRawMaterial"
            ref="unit_type"
            tabindex="3"
          ></v-select>
          <v-select
            :rules="validationRules.supplier_id"
            v-model="editFields.supplier_id"
            :items="suppliers"
            item-text="company_name"
            item-value="id"
            label="Supplier*"
            required
            name="supplier_id"
            :error-messages="inputErrorMessages('supplier_id')"
            v-on:keyup.enter="saveRawMaterial"
            ref="supplier_id"
            tabindex="4"
          ></v-select>

          <v-list subheader>
            <v-subheader class="d-block" style="padding: 0; height: auto;"
              >Specification
              <span
                class="red--text d-block"
                v-bind:key="index"
                v-for="(message, index) in inputErrorMessages('meta')"
                >{{ message }}</span
              >
            </v-subheader>

            <v-list-item
              style="padding: 0;"
              v-for="(spec, index) in editFields.meta"
              v-bind:key="index"
            >
              <v-list-item-content>
                <v-text-field dense :label="spec.specName" v-model="spec.value"></v-text-field>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon color="primary" @click="removeSpec(index)">close</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item style="padding: 0;">
              <v-list-item-content>
                <v-text-field
                  dense
                  label="New Spec name"
                  v-model="editFields.newSpec.name"
                  :error-messages="addSpecError"
                ></v-text-field>
                <v-text-field
                  dense
                  label="New Spec value"
                  v-model="editFields.newSpec.value"
                ></v-text-field>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon
                  color="primary"
                  @click="addSpec(editFields.newSpec.name, editFields.newSpec.value)"
                  >mdi-plus</v-icon
                >
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-form>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="goToShow">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="saveRawMaterial">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      loading: false,
      addSpecError: undefined,
      continousCreation: false,
      createValid: true,
      validationRules: {
        name: [
          v => !!v || this.rem('Name'),
          v => v.length <= 255 || 'Name should not be greater than 255'
        ],
        cost: [
          v => !!v || this.rem('Cost'),
          v => (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) || 'Cost should be a number',
          v => v > 0 || 'Cost should be greater than 0'
        ],
        quantity: [
          v => !!v || this.rem('Quantity'),
          v =>
            (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) || 'Quantity should be a number',
          v => v > 0 || 'Quantity should be greater than 0'
        ],
        supplier_id: [v => !!v || this.rem('Supplier')],
        unit_type: [v => v != '' || this.rem('Unit')]
      },
      errorMessages: {},
      editFields: {
        name: '',
        cost: 0,
        quantity: 0,
        unit_type: '',
        supplier_id: undefined,
        meta: [
          {
            specName: 'size',
            value: 20
          },
          {
            specName: 'weight',
            value: 100
          }
        ],
        newSpec: {
          name: '',
          value: ''
        }
      }
    };
  },
  computed: {
    ...mapState({
      dataloading: state => state.Supplier.getRawMaterialLoading,
      suppliers: state => state.Supplier.plainsuppliers,
      units: state => state.Unit.units,
      rawmaterial(state) {
        if (typeof state.RawMaterial.rawMaterial.data == 'undefined') {
          return {
            name: '',
            cost: 0,
            quantity: 0,
            unit_type: '',
            supplier_id: undefined,
            meta: [
              {
                specName: 'size',
                value: 20
              },
              {
                specName: 'weight',
                value: 100
              }
            ],
            newSpec: {
              name: '',
              value: ''
            }
          };
        }
        return state.RawMaterial.rawMaterial.data;
      },
      units: state => state.Unit.units
    })
  },
  watch: {
    rawmaterial(value) {
      this.editFields.name = value.name;
      this.editFields.cost = value.cost;
      this.editFields.quantity = value.quantity;
      this.editFields.unit_type = value.unit_type;
      this.editFields.supplier_id = value.supplier_id;
      this.editFields.meta = JSON.parse(value.meta);
    }
  },
  mounted() {
    this['Supplier/fetchSuppliers']({ dontPaginate: false });
    this['RawMaterial/getRawMaterial']({ id: this.$route.params.id });
    /*this['Supplier/fetchSuppliers']({ dontPaginate: false }),
    this['RawMaterial/getRawMaterial']({ id: this.$route.params.id }).finally(() => {
      this.editFields.name = this.$store.state.RawMaterial.rawMaterial.data.name;
      this.editFields.cost = this.$store.state.RawMaterial.rawMaterial.data.cost;
      this.editFields.quantity = this.$store.state.RawMaterial.rawMaterial.data.quantity;
      this.editFields.unit_type = this.$store.state.RawMaterial.rawMaterial.data.unit_type;
      this.editFields.supplier_id = this.$store.state.RawMaterial.rawMaterial.data.supplier_id;
      this.editFields.meta = JSON.parse(this.$store.state.RawMaterial.rawMaterial.data.meta);
    });*/
  },
  props: {
    edit: false,
    page: 0
  },
  methods: {
    ...mapActions([
      'RawMaterial/fetchRawMaterials',
      'RawMaterial/getRawMaterial',
      'Supplier/fetchSuppliers'
    ]),
    clearCreate() {},
    rem(name) {
      return `${name} is required`;
    },
    rem(cost) {
      return `${cost} is required`;
    },
    rem(quantity) {
      return `${quantity} is required`;
    },
    rem(unit_type) {
      return `${unit_type} is required`;
    },
    rem(supplier_id) {
      return `${supplier_id} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveRawMaterial() {
      if (1 == 1 || this.$refs.editForm.validate()) {
        this.loading = true;
        let tempEditFields = Object.assign({}, this.editFields);
        tempEditFields.meta = JSON.stringify(tempEditFields.meta);
        axios
          .put(`api/v1/rawmaterial/${this.$route.params.id}`, tempEditFields)
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'RawMaterial saved...',
              color: 'success'
            });
            this.errorMessages = [];
            this.$refs.editForm.resetValidation();
            this['RawMaterial/fetchRawMaterials']({ page: this.page });
            this.$router.push('/rawmaterial');
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$store.commit('SET_SNACK_BAR', {
                message: error.response.data['message'],
                color: 'error'
              });
            } else {
              this.errorMessages = error.response.data.errors;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    removeSpec(index) {
      this.editFields.meta.splice(index, 1);
    },
    addSpec(name, value) {
      if (!!name.trim()) {
        this.editFields.meta.push({
          specName: name,
          value: value
        });
        this.addSpecError = undefined;
      } else {
        this.addSpecError = [this.rem('Specification Name')];
      }
    },
    goToShow() {
      this.$router.push(`/rawmaterial/${this.$route.params.id}`);
    }
  }
};
</script>
